import { styled } from 'styled-components';

import { getStaticImageSrc } from 'utils/getImageSrc';

export const PostAListingPageHolder = styled.div`
  padding-top: 150px;

  background-image: url('${getStaticImageSrc(
    'post-listing-select-type-bg.svg',
  )}');

  background-size: cover;
  background-position: center;
`;
